class ResponsiveBackgroundImage {
	constructor(element) {
		this.element = element;
		this.img = element.querySelector("img");
		this.src = "";
		if (element.querySelector("img") === null) {
			return;
		}
		if (element.querySelector("img")) {
			this.img.addEventListener("load", () => {
				this.update();
			});

			if (this.img.complete) {
				this.update();
			}
		}
	}

	update() {
		let src =
			typeof this.img.currentSrc !== "undefined"
				? this.img.currentSrc
				: this.img.src;
		if (this.src !== src) {
			this.src = src;
			this.element.style.backgroundImage = 'url("' + this.src + '")';
		}
	}
}

let headerImages = document.querySelectorAll(
	"[data-responsive-background-image]"
);
for (let i = 0; i < headerImages.length; i++) {
	new ResponsiveBackgroundImage(headerImages[i]);
}

let responsiveImages = document.querySelectorAll("[data-responsive-image]");
for (let i = 0; i < responsiveImages.length; i++) {
	new ResponsiveBackgroundImage(responsiveImages[i]);
}
